const cartUpdateErrorsMapping = {
  UnknownUpdateCartFailure: "checkout.errors.cartUpdateFailed",
  ShippingMethodDoesNotMatchCartFailure: "checkout.errors.shippingMethodNotMatched",
  ShipmentMethodNotFoundFailure: "checkout.errors.shippingMethodNotFound"
};
const ApplePaySessionErrors = {
  ApplePaySessionUnsupported: "checkout.express.apple.pay.errors.unsupported",
  ApplePaySessionFailed: "checkout.express.apple.pay.errors.failed",
  ApplePayPaymentFailed: "checkout.express.apple.pay.errors.payment.failed",
  ApplePayInvalidAddress: "checkout.express.apple.pay.errors.invalid.address"
};
const GooglePaySessionErrors = {
  GooglePaySessionUnsupported: "checkout.express.google.pay.errors.unsupported",
  GooglePayInvalidAddress: "checkout.express.google.pay.errors.invalid.address"
};
var errorsMapping = /* @__PURE__ */ ((errorsMapping2) => {
  errorsMapping2["SOMETHING_WENT_WRONG"] = "checkout.errors.somethingWentWrong";
  errorsMapping2["ORDER_NOT_FOUND"] = "checkout.errors.orderNotFound";
  return errorsMapping2;
})(errorsMapping || {});
var CheckoutErrorsMapping = /* @__PURE__ */ ((CheckoutErrorsMapping2) => {
  CheckoutErrorsMapping2["CartNotFound"] = "cart.errors.cartNotFound";
  CheckoutErrorsMapping2["CreateOrderFailed"] = "checkout.errors.order.message";
  CheckoutErrorsMapping2["TryAgain"] = "common.errors.recoverable.generic";
  CheckoutErrorsMapping2["PaymentMethodNotFound"] = "checkout.errors.paymentMethods.title";
  CheckoutErrorsMapping2["PaymentFailed"] = "checkout.errors.paymentFailed";
  CheckoutErrorsMapping2["SomethingWentWrong"] = "checkout.errors.form.general";
  CheckoutErrorsMapping2["CartIdNotFound"] = "cart.errors.missingCartID";
  CheckoutErrorsMapping2["OrderNotFound"] = "checkout.errors.orderNotFound";
  return CheckoutErrorsMapping2;
})(CheckoutErrorsMapping || {});
var CreateOrderErrors = /* @__PURE__ */ ((CreateOrderErrors2) => {
  CreateOrderErrors2["UNSUPPORTED_REDIRECT_METHOD"] = "UNSUPPORTED_REDIRECT_METHOD";
  CreateOrderErrors2["PAYMENT_FAILED"] = "PAYMENT_FAILED";
  CreateOrderErrors2["ORDER_CREATION_CALL_FAILED"] = "ORDER_CREATION_CALL_FAILED";
  CreateOrderErrors2["PRODUCT_PRICE_UPDATED"] = "PRODUCT_PRICE_UPDATED";
  return CreateOrderErrors2;
})(CreateOrderErrors || {});
export {
  ApplePaySessionErrors,
  CheckoutErrorsMapping,
  CreateOrderErrors,
  GooglePaySessionErrors,
  cartUpdateErrorsMapping,
  errorsMapping
};
//# sourceMappingURL=errors-mapping.js.map
